<div [formGroup]="netzzuordnungForm">

  <mat-form-field>
    <mat-label>Ortsname</mat-label>
    <mat-select
      formControlName="ortsname"
      required
      data-qa="ortsname"
      name="system"
      (selectionChange)="handleOrtsnameChanged($event.source.value)">
      @for (ortsname of ortsnamenSelection; track ortsname) {
        <mat-option [value]="ortsname">{{ortsname}}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Stationsname</mat-label>
    <mat-select
      formControlName="stationsname"
      [required]="stationsNamenSelection.length > 1"
      data-qa="stationsname"
      name="stationsname"
      (selectionChange)="handleStationsnameChanged($event.source.value)">
      @for (stationsname of stationsNamenSelection; track stationsname) {
        <mat-option [value]="stationsname">{{stationsname}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Trafo-, Feldname, SS</mat-label>
    <mat-select
      formControlName="trafoFeldName"
      [required]="trafoFeldNamenSelection.length > 1"
      data-qa="trafoFeldName"
      name="trafoFeldName"
      (selectionChange)="handleTrafoFeldNameChanged($event.source.value)">
      @for (trafoFeldName of trafoFeldNamenSelection; track trafoFeldName) {
        <mat-option [value]="trafoFeldName">
          {{trafoFeldName}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (recentNetzzuordnung?.deactivated && !selectedNetzzuordnung && !disabled) {
    <mat-error>
      Die vorherige Netzzuordnung ({{assembleDescription(recentNetzzuordnung)}}) wurde vom Leitsystem deaktiviert. Bitte wählen Sie eine neue aus.
    </mat-error>
  }
</div>
